import { type FC } from 'react';
import { Button } from 'Button';
import { Text } from 'Text';
import { type FilterOption } from '../BrowseCourses.types';
import { toggleButtonProps } from '../constants';

type Props = {
    heading: string;
    options: FilterOption[];
};

export const FilterOptionGroup: FC<Props> = ({ heading, options }) => (
    <div>
        <Text as="h3" className="mb-2.5">
            {heading}
        </Text>
        <div className="flex flex-wrap gap-2">
            {options.map(option => (
                <Button
                    key={option.id}
                    {...toggleButtonProps(option.selected)}
                    height={8}
                    className="px-3 pt-px uppercase"
                    onPress={option.onPress}
                >
                    {option.label}
                </Button>
            ))}
        </div>
    </div>
);
